import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    titleDivider: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      margin: '0px 18px 0px 10px',
      opacity: 0.6,
      cursor: 'pointer',
    },
    colorContainer: {
      position: 'relative',
    },
    colorContent: {
      position: 'absolute',
      zIndex: 1000,
      top: -40,
    },
    buttons: {
      margin: '40px auto 16px',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
    divider: {
      marginTop: 30,
      background: 'none',
    },
    diverTitle: {
      marginBottom: 16,
      background: 'none',
    },
    imageDrop: {
      '& .MuiDropzonePreviewList-root': {
        justifyContent: 'center',
      },

      '& .MuiDropzonePreviewList-imageContainer': {
        padding: '32px 0 0 0',
      },
    },
    imageTitle: {
      fontSize: 14,
    },
    checkbox: {
      color: `${palette.error.light} !important`,
      margin: '0px 6px 0px 0px !important',
      width: 5,
      height: 5,
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: `${palette.error.light} !important`,
      },
      '& .MuiSvgIcon-root': { width: '0.8em', height: '0.8em' },
    },
    imagesTitle: { display: 'flex', alignItems: 'center', paddingBottom: 8 },
    removeImagesGrid: { display: 'flex', justifyContent: 'flex-end' },
    removeImagesButton: {
      color: palette.error.light,
      borderColor: palette.error.light,
    },
    editIcon: {
      width: 20,
      height: 20,
      cursor: 'pointer',
      margin: '0px 3px',
      color: palette.blue,
    },
    helpIconImage: {
      width: 20,
      height: 20,
      color: palette.sideGray,
      cursor: 'pointer',
      marginRight: 3,
    },
    helpGrid: { display: 'flex' },
    description: { padding: 15 },
    colorGrid: { alignItems: 'center', display: 'flex', padding: '15px 8px' },
    titleText: { marginBottom: 8 },
    helpIconImageRight: {
      marginLeft: 35,
      width: 20,
      height: 20,
      color: palette.sideGray,
      cursor: 'pointer',
      marginRight: 3,
    },
    loadingContainer: {
      justifyContent: 'center',
      marginTop: 100,
    },
    deleteButton: {
      backgroundColor: palette.error.main,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.error.main,
      },
      border: `1px solid ${palette.error.main}`,
    },
    deleteButtons: {
      marginTop: 15,
    },
    deleteText: { fontSize: 14, fontWeight: 500 },
    deleteTextGrid: {
      margin: '5px 10px 25px 10x',
      paddingBottom: 15,
    },
    deleteSubtext: { fontSize: '11px', display: 'flex', alignItems: 'center' },
    warningIcon: {
      color: palette.error.main,
      width: 15,
      height: 15,
      marginRight: 5,
    },
    deleteSubtextGrid: { display: 'flex', marginTop: 10 },
    accessAccount: {
      color: palette.blue,
      borderColor: palette.blue,
      marginRight: 8,
    },
    accessAccountIcon: {
      color: palette.blue,
      borderColor: palette.blue,
    },
    defaultBannerGrid: { alignItems: 'center', display: 'flex' },
    bannerImageOptions: {
      border: `1px solid ${palette.sideGray}`,
      borderRadius: 8,
      display: 'flex',
      alignItems: 'center',
      marginRight: 16,
    },
    orText: { color: palette.sideGray, marginRight: 40 },
    defaultImageButton: { color: palette.blue, borderColor: palette.blue },
    defaultImageButtonActive: {
      color: palette.green,
      borderColor: palette.green,
    },
    defaultImageItem: {
      padding: 8,
      margin: 6,
      maxWidth: '32%',
      width: '32%',
      cursor: 'pointer',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
    },
    cardSelectorActive: {
      padding: 8,
      border: `1px solid ${palette.green}`,
      margin: 6,
      borderRadius: 4,
      maxWidth: '32%',
      width: '32%',
      backgroundColor: palette.lightGreen,
    },
    checkIconModal: {
      fontSize: 20,
      color: palette.green,
      visibility: 'visible',
      marginBottom: 8,
    },
    checkIconModalHidden: { visibility: 'hidden' },
    iconGrid: { justifyContent: 'flex-end', display: 'flex' },
    imagesOptionsGrid: { marginTop: 8 },
    configText: {
      '& .MuiOutlinedInput-inputMultiline': { height: 'auto !important' },
    },
  });

export const overrideModal = {
  content: {
    padding: 0,
    fontSize: '12px !important',
    overflowX: 'auto',
    width: '100%',
  },
};
